export default "__VITE_ASSET__B1BUFx5M__"